export default __webpack_public_path__ + "static/media/warning.7633ce0d.svg";